import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'popup-modal',
  templateUrl: './popup-modal.component.html',
  styleUrls: ['./popup-modal.component.scss']
})
export class PopupModalComponent implements OnInit {
  @Input() openModal!: EventEmitter<boolean>;
  @Input() canClose: boolean = true;
  @Output() onClose: EventEmitter<void> = new EventEmitter();

  public isOpen: boolean = false;

  public ngOnInit(): void {
    this.openModal.subscribe(value => {
      this.isOpen = value;
    })
  }
}
